export class BadGatewayError extends Error {
	get skipLogging() {
		return true
	}

	constructor(message: string) {
		super(message)
		this.name = 'BadGatewayError'

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, BadGatewayError)
		}
	}
}
